import React, { useState } from "react";
import { Link } from "react-router-dom";
import Layout from "../../layout/common/authLayout";
import CustomButton from "shared/components/inputButton";
import { CustomInput } from "../../shared/components/allInput";
import formValidation from "utils/validations";
import { showFormErrors } from "utils/CommonFunctions";
import { useDispatch } from "react-redux";
import { forgotPasswordAction } from "store/actions/AuthActions";
import OtpVerification from "pages/Auth/OtpVerification";
import ResetPassword from "./ResetPassword";

export default function ForgotPassword() {
  const dispatch = useDispatch()
  const [data, setData] = useState({
    email: "",
  })
  const [loading, setLoading] = useState(false)
  const [step, setStep] = useState(0)

  const handleChange = ({ name, value }) => {
    const formErrors = formValidation(name, value, data)
    setData((prev) => ({ ...prev, [name]: value, formErrors }))
  }

  const onSubmit = async () => {
    if (showFormErrors(data, setData)) {
      dispatch(forgotPasswordAction(data, setLoading, dispatch, (res) => {
        setStep(1)
      }))
    }
  };

  return (
    <>
      {step == 1 ? <OtpVerification data={data} type={2} setStep={setStep} /> : step == 2 ? <ResetPassword email={data?.email} /> :
        // <Layout
        //   title=" Reset Your Password"
        //   description="Enter your email and we’ll send you instructions on how to reset your
        // password."
        // >
        <>
          <h2 className={`text-2xl md:text-4xl text-left py-1 mb-2`}>
            Reset Your Password
          </h2>
          <p className="text-lg text-left">Enter your email and we’ll send you instructions on how to reset your
            password.</p>
          <form className="mt-5 pt-2">
            <CustomInput name="email" data={data} col={12} onChange={handleChange} />
            <CustomButton
              label="Send Reset Instructions"
              extraClassName="w-full my-5"
              type="button"
              onClick={onSubmit}
              loading={loading}
            ></CustomButton>
            <p className="mt-2 text-center">
              Or go back to the{" "}
              <Link to="/login" className="underline color-black">
                login page.
              </Link>
            </p>
          </form>
        </>
        // </Layout >
      }
    </>

  );
}
